






























import { Component, Mixins } from 'vue-property-decorator';
import CardMixin from '../common';
import { Video, Videos } from '../types';

@Component
export default class PageOrganizationCardVideos extends Mixins(CardMixin) {
  currentVideoIndex = 0;

  get videos(): Videos {
    return this.organization.videos || [];
  }

  get hasVideos(): boolean {
    return this.videos.length > 0;
  }

  get currentVideo(): Video | undefined {
    return this.videos[this.currentVideoIndex];
  }

  showPrevious() {
    this.currentVideoIndex--;
  }

  showNext() {
    this.currentVideoIndex++;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/organizations/card/videos/component.vue